var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuote = function SvgQuote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.816 6.176c1.232-1.21 2.9-2.193 4.713-2.722V3c-2.973.227-5.8 1.437-7.904 3.328C1.305 8.445 0 11.168 0 14.193c0 1.815.508 3.48 1.378 4.69C2.32 20.318 3.77 21 5.51 21c1.377 0 2.682-.53 3.625-1.437s1.45-2.193 1.45-3.706c0-1.21-.362-2.269-1.16-3.176-.653-.832-1.668-1.362-2.828-1.589H4.35c.218-1.815 1.016-3.479 2.466-4.916m12.471 0c1.233-1.21 2.9-2.193 4.713-2.722V3c-2.973.227-5.8 1.437-7.903 3.328-2.32 2.117-3.626 4.84-3.626 7.865 0 1.815.508 3.48 1.378 4.69C14.79 20.318 16.242 21 17.982 21c1.378 0 2.683-.53 3.625-1.437s1.45-2.193 1.45-3.706c0-1.21-.362-2.269-1.16-3.176-.652-.832-1.667-1.362-2.827-1.589h-2.248c.217-1.815 1.015-3.479 2.465-4.916"
  })));
};
export { SvgQuote as ReactComponent };